export const testPassword = (str: string) => /\d/.test(str);
export const containsUpper = (value: string) => /[A-Z]/.test(value);
export const containsLower = (value: string) => /[a-z]/.test(value);
